import React from 'react';
import { motion } from 'framer-motion';

const StatsCard = ({ title, value, icon, color = 'blue', change, trend, gradient, onClick }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.05, rotateX: 5 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      onClick={onClick}
      className="group cursor-pointer"
    >
      <div className="relative bg-white/80 backdrop-blur-xl rounded-2xl p-6 shadow-xl border border-white/20 overflow-hidden">
        {/* Animated Background */}
        <div className={`absolute inset-0 bg-gradient-to-r ${gradient || `from-${color}-500 to-${color}-600`} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
        
        {/* Content */}
        <div className="relative z-10">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-14 h-14 bg-gradient-to-r ${gradient || `from-${color}-500 to-${color}-600`} rounded-2xl flex items-center justify-center text-2xl text-white shadow-lg group-hover:scale-110 transition-transform duration-200`}>
              {icon}
            </div>
            {change && (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.3 }}
                className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium ${
                  trend === 'up' ? 'bg-green-100 text-green-800' : 
                  trend === 'down' ? 'bg-red-100 text-red-800' : 
                  'bg-gray-100 text-gray-800'
                }`}
              >
                <span className="text-sm">
                  {trend === 'up' && '↗'}
                  {trend === 'down' && '↘'}
                  {trend === 'neutral' && '→'}
                </span>
                {change}
              </motion.div>
            )}
          </div>
          
          <div className="space-y-2">
            <h3 className="text-sm font-medium text-gray-600 uppercase tracking-wide">
              {title}
            </h3>
            <motion.p 
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.1, type: "spring", stiffness: 200 }}
              className="text-3xl font-bold text-gray-900"
            >
              {typeof value === 'number' ? value.toLocaleString() : value || '0'}
            </motion.p>
            <p className="text-xs text-gray-500">vs last month</p>
          </div>
        </div>

        {/* Hover Effect */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>
    </motion.div>
  );
};

export default StatsCard;
